import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useStyles } from '../OffersComponent/OffersComponent.styles'
import { useTheme } from '@mui/material/styles'
import { TotalAndPercentage } from '../TotalAndPercentage/TotalAndPercentage'
import { CustomLegends } from '../CustomLegends/CustomLegends'
import { LineChartComponent } from '../../../common/components/LineChartComponent/LineChartComponent'
import { Typography } from '@mui/material'
import { OverviewEmptyState } from '../OverviewEmptyState/OverviewEmptyState'
import { numberFormat } from '@labrav/common'
import OverviewEmptyStateImage from '../../../common/images/overviewEmptyState.png'
import { isEmpty } from 'lodash'

interface Props {
  resellerAgreementCount: number
  currency?: string
  link?: string
}
export const ResellerComponent: React.FC<Props> = ({
  resellerAgreementCount,
  currency = '',
  link = '',
}) => {
  const { classes } = useStyles()
  const theme = useTheme()
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(link)
  }

  const resellerList = {
    aws: { count: resellerAgreementCount, percentage: 0 },
    microsoft: { count: 0, percentage: 0 },
    gcp: { count: 0, percentage: 0 },
  }

  return (
    <>
      {resellerAgreementCount === 0 || resellerAgreementCount === null ? (
        <OverviewEmptyState
          imgUrl={OverviewEmptyStateImage}
          containerHeight={20.5}
          imageHeight={12}
          imageWidth={16.75}
          description="It's time to create your first offer."
          button={
            <div
              className={classes.viewEmptyDetailsContainer}
              data-testid="buyers-view-details"
            >
              <Typography
                className={classes.viewDetailsText}
                onClick={handleClick}
              >
                View details
              </Typography>
            </div>
          }
        />
      ) : (
        <div
          data-testid={'offers-for-resellers-component'}
          className={classes.root}
        >
          <TotalAndPercentage
            total={resellerAgreementCount}
            percentage={undefined}
            type={undefined}
            currency={currency}
          />
          <div
            className={classes.lineChartComponent}
            data-testid={'resellers-line-chart'}
          >
            <LineChartComponent
              classes={classes}
              data={resellerList}
              colors={[
                theme.palette.awsGraph.main,
                theme.palette.microsoftGraph.main,
                theme.palette.gcpGraph.main,
              ]}
            />
            <div
              className={classes.legendsWrapper}
              data-testid={'resellers-custom-legend-wrapper'}
            >
              <CustomLegends
                legends={[
                  {
                    label: 'AWS:',
                    legendColor: theme.palette.awsGraph.main,
                    legendSize: 'small',
                    value: String(numberFormat(resellerAgreementCount || 0)),
                  },
                  {
                    label: 'Microsoft:',
                    legendColor: theme.palette.microsoftGraph.main,
                    legendSize: 'small',
                    value: String(numberFormat(0)),
                  },
                  {
                    label: 'GCP:',
                    legendColor: theme.palette.gcpGraph.main,
                    legendSize: 'small',
                    value: String(numberFormat(0)),
                  },
                ]}
              />
            </div>
          </div>
          {!isEmpty(link) && (
            <div
              className={classes.viewDetailsContainer}
              data-testid="resellers-view-details"
            >
              <Typography
                className={classes.viewDetailsText}
                onClick={handleClick}
              >
                View details
              </Typography>
            </div>
          )}
        </div>
      )}
    </>
  )
}
